function getUnifySelectInventoryJoinDetailCheckResultItem({
  taskInfoVOList,
  commodityId,
  dictPromotionTypeList
}) {
  var _a;
  const [taskInfo] = taskInfoVOList;
  const { resultDesc } = taskInfo.checkDataResultVO || {};
  if (!resultDesc)
    return [];
  const { activities = {} } = JSON.parse(resultDesc);
  const dictionary = new Map(dictPromotionTypeList.map(({ label: activityName, value: activityType }) => [
    activityType,
    {
      activityName,
      activityType,
      field: "activityType"
    }
  ]));
  return (_a = activities[commodityId]) == null ? void 0 : _a.map((activity) => typeof activity === "object" ? Object.assign(activity, { field: "activityTypeId" }) : dictionary.get(activity));
}
export { getUnifySelectInventoryJoinDetailCheckResultItem };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getJoinDetailCheckResultItem.js